module.exports = __webpack_public_path__ + "media/images/front/pc/dummy/sample-pc-738eb7f91e195f92ef5a9e41568f4868.png";